export default __webpack_public_path__ + "static/media/img8.6bc04265.png";